import {
    RaikoButtonSecondary, RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoGridTwoColumn, RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoToggleOutlined, showServerErrorMessage, showSuccessMessage,
    RaikoCardInfoTypeOne,RaikoCardInfoTypeOneItemGenerator
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useEffect, useState} from "react";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {RouteHelper} from "../../../route/RouteHelper";

export default function ResidenceAddInfo({periodId, residenceInfo, handleBackPage, handleCloseDialogAdd}) {


    const service = new PeriodService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {

        if (residenceInfo) {
            setManCapacity(residenceInfo.menCapacity)
            setWomanCapacity(residenceInfo.womenCapacity)
        }
        console.log("residenceInfo is here", residenceInfo)
    }, [residenceInfo])


    const [manCapacity, setManCapacity] = useState(0);
    const [womanCapacity, setWomanCapacity] = useState(0);
    const [priority, setPriority] = useState(0);
    const [getResidenceState, setGetResidenceState] = useState(true);
    const [checkRequestAuto, setCheckRequestAuto] = useState(true);


    function handleAddNewResidence() {
        loading.show()
        service.addNewResidenceToPeriod(
            periodId,
            residenceInfo.id,
            manCapacity,
            womanCapacity,
            priority,
            getResidenceState,
            checkRequestAuto
        ).then(response => {
            setManCapacity(0)
            setWomanCapacity(0)
            setPriority(0)
            setGetResidenceState(true)
            setCheckRequestAuto(true)
            showSuccessMessage("اقامتگاه جدید با موفقیت افزوده شد!")
            handleCloseDialogAdd()
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <RaikoGridOneColumn className={css`width: 100%;
                gap: 1.5rem;`}>
                <div className={css`display: grid;
                    grid-template-columns: 1fr 2fr;
                    gap: 1rem;
                    height: max-content;
                    @media screen and (max-width: 425px){
                        grid-template-columns: 1fr;
                    }
                `}>
                    <div>
                        <RaikoCardInfoTypeOne
                            title={residenceInfo.title}
                            iconClass={"ic_residence"}
                            hasBottomChildren
                            items={[
                                RaikoCardInfoTypeOneItemGenerator("تعداد آقا", residenceInfo.menCapacity),
                                RaikoCardInfoTypeOneItemGenerator("تعداد خانم", residenceInfo.womenCapacity),
                                RaikoCardInfoTypeOneItemGenerator("آدرس", residenceInfo.address),
                            ]}

                        >
                            <RaikoFlexAlignEnd>
                                <RaikoButtonSecondary
                                    label={"جزئیات"}
                                    onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        window.open(RouteHelper.ResidenceDetail.globalUrl.replace(":id", residenceInfo.id) + `?title=${encodeURIComponent(residenceInfo.title)}`, "_blank")
                                    }}/>
                            </RaikoFlexAlignEnd>
                        </RaikoCardInfoTypeOne>

                    </div>

                    <RaikoSectionContainer
                        title={"وضعیت اسکان"}
                        hasActionButton
                        hasSecondaryButton
                        actionButtonTitle={"ثبت اقامتگاه"}
                        secondaryButtonTitle={"بازگشت"}
                        actionButtonOnclickWithValidation={handleAddNewResidence}
                        secondaryButtonOnClick={handleBackPage}
                    >
                        <RaikoGridOneColumn>
                            <RaikoGridThreeColumn>
                                <RaikoNumberInputOutlined
                                    labelText={"اولویت"}
                                    setValue={setPriority}
                                    value={priority}
                                    required
                                />
                                <RaikoNumberInputOutlined
                                    labelText={"تعداد آقا"}
                                    setValue={setManCapacity}
                                    value={manCapacity}
                                    required
                                />
                                <RaikoNumberInputOutlined
                                    labelText={"تعداد خانم"}
                                    setValue={setWomanCapacity}
                                    value={womanCapacity}
                                    required
                                />
                            </RaikoGridThreeColumn>
                            <RaikoGridTwoColumn>
                                <RaikoToggleOutlined
                                    labelText={"وضعیت پذیرش"}
                                    setChecked={setGetResidenceState}
                                    checked={getResidenceState}/>
                                <RaikoToggleOutlined
                                    labelText={"بررسی خودکار درخواست ها"}
                                    setChecked={setCheckRequestAuto}
                                    checked={checkRequestAuto}/>
                            </RaikoGridTwoColumn>

                        </RaikoGridOneColumn>

                    </RaikoSectionContainer>
                </div>


            </RaikoGridOneColumn>

        </>
    )
}